import { types } from 'mobx-state-tree';
import { model, Model } from 'mst-collection';

export class TariffPlanSave extends Model({
  fromCode: types.number,
  toCode: types.number,
  value: types.string,
}) {
  get formattedValue(): string {
    return `\u00A3\u00A0${this.value}`;
  }
}

export const TariffPlanSaveModel = model(TariffPlanSave);
